import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { each, toString, upperCase } from 'lodash-es';

export default class GetUsers extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'users-getUsers',
      payload: this._payload
        ? {
            resolve_links: this._payload.resolve_links || false,
            skip: this._payload.skip || null,
            limit: this._payload.limit || null,
            search_fields: this._payload.search_fields || null,
          }
        : {},
    });
  }

  onSuccess(data: any) {
    // If it is a concatination query data is added to existing data results
    if (this._payload.concat) {
      data = this._state.admin.users.data.concat(data);
    }
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        admin: {
          users: {
            tabledData: this.formatToTable(data),
            data: data,
          },
        },
      },
    });
    super.onSuccess(data);
  }

  /**
   * Prepare users data for flat datatable formatting
   */
  formatToTable = (data: any) => {
    const tableData: any[] = [];
    each(data, (user) => {
      tableData.push([
        // Name
        upperCase(`${user.first} ${user.last}`),
        // Email
        user.email,
        // Teams
        toString(
          (() => {
            let teams: any[] = [];
            each(user.teams, (t) => {
              if (t) {
                teams.push(t.name);
              }
            });
            return teams.length ? teams : ['N/A'];
          })().join(', ')
        ).toUpperCase(),
        // Role
        upperCase(`${user.role}`),
        // ID
        `${user.doc_id}`,
        // Raw Data
        user,
      ]);
    });
    return tableData;
  };
}
